import { jsx as _jsx } from "react/jsx-runtime";
import { mdiTrashCanOutline } from '@mdi/js';
import { Icon } from '@mdi/react';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { FormattedMessage } from 'react-intl';
import { defineStyles, theme } from '../../theme';
const tooltip = {
    id: 'tableFiltering.removeFilter.tooltip',
    defaultMessage: 'Remove filter',
};
const styles = defineStyles({
    m: `auto 0 0 ${theme.spacing(1)}`,
    color: theme.vars.palette.grey[700],
});
export const RemoveFilterButton = ({ onClick, disabled, sx }) => (_jsx(Tooltip, { title: _jsx(FormattedMessage, { ...tooltip }), children: _jsx("span", { children: _jsx(IconButton, { size: "small", disabled: disabled, onClick: onClick, sx: { ...styles, ...sx }, children: _jsx(Icon, { size: 0.8, path: mdiTrashCanOutline }) }) }) }));
//# sourceMappingURL=RemoveFilterButton.js.map